// File: src/Pages/Home.jsx
import React from 'react';
import { motion } from 'framer-motion';
import Bg from '../Assets/Img/bg3.png'
import logo from '../Assets/Img/Gold-logo.png';

const Home = () => {
  return (
    <div className="flex h-screen bg-cover bg-center" style={{ backgroundImage: `url(${Bg})` }}
    >
    <div className="flex-1 min-h-screen bg-cover bg-center flex items-center justify-center px-4" >
        <motion.div
          className="bg-white bg-opacity-90 p-8 rounded-xl shadow-xl max-w-xl text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          style={{marginTop:"-115px"}}
        >
           <img
                    src={logo}
                    alt="Login Logo"
                    className="mx-auto mb-2 w-16 h-16 rounded-full object-cover border border-gray-300"
                  />
          <h1 className="text-3xl md:text-4xl font-bold mb-3 text-gray-800">
            MIS Dashboards
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            Access Purchase and Sales Dashboard
          </p>
          {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://app.powerbi.com/view?r=eyJrIjoiMWJiZmRmNjYtNzc3ZC00NGIyLWI1OWEtMTg3NzFjNmU5YWIyIiwidCI6IjhjMDYwZTQzLTM1MTEtNGIwZC1iZGI1LTg4NTA2ZmExYmI2MyJ9"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
            >
              View Sales Dashboard
            </a>
            <a
              href="https://app.powerbi.com/view?r=eyJrIjoiNzE2ZTQ5NTYtM2MxZC00MzhjLWFlNzEtNjJlMzA0ZGZkMmRiIiwidCI6IjhjMDYwZTQzLTM1MTEtNGIwZC1iZGI1LTg4NTA2ZmExYmI2MyJ9"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 transition"
            >
              View Purchase Dashboard
            </a>
          </div> */}
        </motion.div>
      </div>
    </div>
  );
};

export default Home;